import React, { useEffect } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import '../ServicePage.css';

function Proxmox() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="service-page">
            <Container>
                <div className="service-header">
                    <h1 className="service-title gradient-text">Proxmox VE & Virtualizzazione</h1>
                    <p className="service-description">
                        Virtualizzazione open source con Proxmox VE, backup affidabili con
                        Proxmox Backup Server e migrazione da VMware senza interruzioni.
                    </p>
                </div>

                <Row className="mb-5">
                    <Col lg={12}>
                        <Card className="service-card">
                            <Card.Body>
                                <h2 className="section-title">Cos'è Proxmox VE?</h2>
                                <p className="section-description">
                                    Proxmox Virtual Environment è una piattaforma di virtualizzazione open source
                                    completa: macchine virtuali KVM, container LXC, storage, rete e backup
                                    gestiti da un'unica interfaccia web. Senza costi di licenza e senza vendor lock-in.
                                </p>

                                <div className="proxmox-features">
                                    <Row>
                                        <Col md={6}>
                                            <div className="feature-item">
                                                <i className="fas fa-layer-group text-primary"></i>
                                                <strong>VM e Container</strong>
                                                <p>Virtualizzazione KVM completa e container LXC leggeri sulla stessa piattaforma</p>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="feature-item">
                                                <i className="fas fa-server text-primary"></i>
                                                <strong>Cluster e Alta Disponibilità</strong>
                                                <p>Cluster multi-nodo con live migration e failover automatico delle VM</p>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="feature-item">
                                                <i className="fas fa-hard-drive text-primary"></i>
                                                <strong>Backup Integrato</strong>
                                                <p>Snapshot, repliche e backup deduplicati con Proxmox Backup Server</p>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="feature-item">
                                                <i className="fas fa-unlock text-primary"></i>
                                                <strong>Open Source, Zero Licenze</strong>
                                                <p>Nessun costo di licenza per socket o per core: solo il supporto, se lo vuoi</p>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row className="mb-5">
                    <Col lg={12}>
                        <Card className="service-card highlight-card">
                            <Card.Body>
                                <h2 className="section-title">I Nostri Servizi Proxmox</h2>

                                <Row>
                                    <Col lg={6} className="mb-4">
                                        <div className="service-item">
                                            <div className="service-icon">
                                                <i className="fas fa-server text-primary"></i>
                                            </div>
                                            <h4>Installazione e Configurazione</h4>
                                            <p>
                                                Progettiamo e installiamo il tuo cluster Proxmox VE: nodi, storage
                                                (ZFS, Ceph, NFS), rete e alta disponibilità configurati a regola d'arte.
                                            </p>
                                            <ul>
                                                <li>Cluster multi-nodo con HA</li>
                                                <li>Storage ZFS, Ceph e condiviso</li>
                                                <li>Rete VLAN e SDN</li>
                                            </ul>
                                        </div>
                                    </Col>

                                    <Col lg={6} className="mb-4">
                                        <div className="service-item">
                                            <div className="service-icon">
                                                <i className="fas fa-hard-drive text-primary"></i>
                                            </div>
                                            <h4>Proxmox Backup Server</h4>
                                            <p>
                                                Backup incrementali e deduplicati di VM e container con
                                                Proxmox Backup Server: ripristini rapidi, verifica automatica
                                                e copie off-site per la massima sicurezza.
                                            </p>
                                            <ul>
                                                <li>Backup deduplicati e incrementali</li>
                                                <li>Verifica automatica dei backup</li>
                                                <li>Replica off-site e retention policy</li>
                                            </ul>
                                        </div>
                                    </Col>

                                    <Col lg={6} className="mb-4">
                                        <div className="service-item">
                                            <div className="service-icon">
                                                <i className="fas fa-arrow-right-arrow-left text-primary"></i>
                                            </div>
                                            <h4>Migrazione da VMware a Proxmox</h4>
                                            <p>
                                                Migrare da VMware ESXi/vSphere a Proxmox VE senza fermare l'attività:
                                                pianifichiamo ogni passaggio e ti affianchiamo fino al collaudo finale.
                                            </p>
                                            <ul>
                                                <li>Assessment dell'infrastruttura esistente</li>
                                                <li>Piano di migrazione con downtime minimo</li>
                                                <li>Conversione VM e test di collaudo</li>
                                            </ul>
                                        </div>
                                    </Col>

                                    <Col lg={6} className="mb-4">
                                        <div className="service-item">
                                            <div className="service-icon">
                                                <i className="fas fa-chart-line text-primary"></i>
                                            </div>
                                            <h4>Gestione e Monitoraggio</h4>
                                            <p>
                                                Amministriamo il tuo cluster nel tempo: aggiornamenti, monitoraggio
                                                proattivo, ottimizzazione delle risorse e supporto continuo.
                                            </p>
                                            <ul>
                                                <li>Patch e aggiornamenti pianificati</li>
                                                <li>Monitoraggio risorse e allerte</li>
                                                <li>Assistenza sistemistica dedicata</li>
                                            </ul>
                                        </div>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row className="mb-5">
                    <Col lg={12}>
                        <Card className="service-card">
                            <Card.Body>
                                <h2 className="section-title">Perché Migrare da VMware a Proxmox?</h2>

                                <Row>
                                    <Col md={4} className="text-center mb-4">
                                        <div className="advantage-item">
                                            <div className="advantage-icon">
                                                <i className="fas fa-euro-sign text-primary"></i>
                                            </div>
                                            <h5>Costi sotto controllo</h5>
                                            <p>Nessuna licenza per socket o subscription obbligatoria: budget prevedibile</p>
                                        </div>
                                    </Col>

                                    <Col md={4} className="text-center mb-4">
                                        <div className="advantage-item">
                                            <div className="advantage-icon">
                                                <i className="fas fa-unlock text-primary"></i>
                                            </div>
                                            <h5>Nessun vendor lock-in</h5>
                                            <p>Piattaforma open source: i tuoi dati e le tue VM restano tuoi</p>
                                        </div>
                                    </Col>

                                    <Col md={4} className="text-center mb-4">
                                        <div className="advantage-item">
                                            <div className="advantage-icon">
                                                <i className="fas fa-headset text-primary"></i>
                                            </div>
                                            <h5>Migrazione assistita</h5>
                                            <p>Ti seguiamo noi in ogni fase, dall'assessment al collaudo finale</p>
                                        </div>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row className="mb-5">
                    <Col lg={12}>
                        <Card className="service-card cta-card">
                            <Card.Body className="text-center">
                                <h3>Vuoi Virtualizzare o Migrare a Proxmox?</h3>
                                <p className="mb-4">
                                    Contattaci per una consulenza gratuita: valutiamo la tua infrastruttura
                                    e ti proponiamo il percorso migliore, senza impegno.
                                </p>
                                <a href="#contact" className="btn btn-primary btn-lg">
                                    Richiedi Consulenza Gratuita
                                </a>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Proxmox;
